module.exports = __webpack_public_path__ + "img/area.ac9cf4b9.png";